'use client';

import { useAuthModal } from '@/context/AuthModalContext';
import { useCreatePurchase } from '@/hooks/useCreatePurchase';
import { useUser } from '@/hooks/useUser';
import { useGetUserProducts } from '@/hooks/useUserProducts';
import { Button } from '@mui/material';
import { useRouter } from 'next/navigation';
import { useState } from 'react';
const PurchaseButtonComponent = ({
  productCode,
  price
}: {
  productCode: string;
  price: number;
}) => {
  const {
    mutate: createPurchase,
    isPending
  } = useCreatePurchase();
  const [isPurchasing, setIsPurchasing] = useState(false);
  const router = useRouter();
  const handlePurchase = async () => {
    try {
      await createPurchase({
        productCode
      }, {
        onSuccess: () => {
          setIsPurchasing(true);
          router.push(`/exams/${productCode}`);
        }
      });
    } catch (error) {
      console.error('Purchase failed:', error);
      // alert('Purchase failed. Please try again.');
    }
  };
  const purchaseString = price === 0 ? 'Purchase for FREE' : `Purchase for $${price.toFixed(2)}`;
  return <Button onClick={handlePurchase} disabled={isPending} variant="contained" color="primary" loading={isPending || isPurchasing} data-sentry-element="Button" data-sentry-component="PurchaseButtonComponent" data-sentry-source-file="PurchaseButton.tsx">
      {isPending ? 'Processing...' : purchaseString}
    </Button>;
};
const UserPurchaseButton = ({
  productCode,
  price
}: {
  productCode: string;
  price: number;
}) => {
  // this will be shown if the user exists and we have not determined yet if the user has these products
  const {
    data: userProducts,
    isLoading
  } = useGetUserProducts();
  const [isRouting, setIsRouting] = useState(false);
  const ownsProduct = !!(userProducts?.userProducts || [])?.some(product => product.productCode === productCode);
  const router = useRouter();
  if (isLoading) {
    <Button disabled variant="contained" color="primary" loading>
      Loading...
    </Button>;
  }
  if (ownsProduct) {
    return <Button onClick={() => {
      setIsRouting(true);
      router.push(`/exams/${productCode}`);
    }} variant="contained" color="primary" loading={isRouting}>
        Take practice exams
      </Button>;
  }
  return <PurchaseButtonComponent productCode={productCode} price={price} data-sentry-element="PurchaseButtonComponent" data-sentry-component="UserPurchaseButton" data-sentry-source-file="PurchaseButton.tsx" />;
};
const PurchaseButton = ({
  productCode,
  price
}: {
  productCode: string;
  price: number;
}) => {
  const {
    data: user,
    isLoading
  } = useUser();
  const {
    openModal
  } = useAuthModal();
  if (isLoading) {
    <Button disabled variant="contained" color="primary" loading>
      Loading...
    </Button>;
  }
  if (user) {
    return <UserPurchaseButton productCode={productCode} price={price} />;
  }
  const purchaseString = price === 0 ? 'Purchase for FREE' : `Purchase for $${price.toFixed(2)}`;
  return <Button onClick={() => {
    openModal('signUp');
  }} variant="contained" color="primary" data-sentry-element="Button" data-sentry-component="PurchaseButton" data-sentry-source-file="PurchaseButton.tsx">
      {purchaseString}
    </Button>;
};
export default PurchaseButton;